import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import { CONSTANT } from '../../utils/constants';
import { GlobalContext } from '../../utils/GlobalContext';
import { CommonFilter } from './FilterOption/CommonFilter';
import SliderImages from './FilterOption/SliderImages';
import SpinnerComponent from '../../utils/SpinnerComponent';
import '../../../css/SingleRingBuilder/RingBannerWorthmore.css';

const colorSuffixMap = {
    'Yellow Gold': '-YG',
    'Rose Gold':   '-RG',
    'White Gold':  '',
    'PLATINUM':    '',
    'SILVER':      '',
};

const RingBanner = ({ handlePagesChanges, clinetDetails }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isRecDiamond, setIsRecDiamond] = useState(true);
    const [accountNo, setAccountNo] = useState(true);
    const [ringCategory, setRingCategory] = useState('Most-Popular');
    const [overAllMetalColor, setOverMetalColor] = useState('White Gold');
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [ringCategoryList, setRingCategoryList] = useState([]);
    const [ringCategoryItem, setRingCategoryItem] = useState();

    const { accessToken } = useContext(GlobalContext);

    const METAL_SWATCHES = [
        { label: 'White Gold',  color: '#e8e8e8', border: '#bbb' },
        { label: 'Yellow Gold', color: '#fae1a1', border: '#c9a830' },
        { label: 'Rose Gold',   color: '#fddfbd', border: '#c97060' },
        { label: 'Platinum',    color: '#d4d4e0', border: '#9090aa' },
    ];

    const renderWorthmoreSwatches = (activeColor, onClick) => (
        <div className="wm-swatches">
            {METAL_SWATCHES.map(swatch => (
                <button
                    key={swatch.label}
                    type="button"
                    title={swatch.label}
                    onClick={() => onClick(swatch.label)}
                    className={`wm-swatch-item${activeColor === swatch.label ? ' active' : ''}`}
                >
                    <span
                        className="wm-swatch-dot"
                        style={{ background: `radial-gradient(circle at 30% 30%, #fff, ${swatch.color})` }}
                    />
                    <span>{swatch.label}</span>
                </button>
            ))}
        </div>
    );

    const WM_BADGES = [
        {
            label: 'Expert Guidance',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 3h12l4 6-10 12L2 9z" />
                    <path d="M2 9h20" />
                    <path d="M9 3l3 6-3 12" />
                    <path d="M15 3l-3 6 3 12" />
                </svg>
            ),
        },
        {
            label: 'Custom Designs',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10 22 L10 6 L12 2 L14 6 L14 22 Z" transform="rotate(45 12 12)" />
                    <path d="M10 22 L10 6 L12 2 L14 6 L14 22 Z" transform="rotate(-45 12 12)" />
                </svg>
            ),
        },
        {
            label: 'Trusted Since 1994',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
                </svg>
            ),
        },
        {
            label: 'Lifetime Care',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 19h18" />
                    <path d="M4 19l-1.5-10 5 4.5L12 5l4.5 8.5 5-4.5L20 19z" />
                    <circle cx="3.2" cy="8.8" r="0.9" fill="currentColor" stroke="none" />
                    <circle cx="12" cy="5" r="0.9" fill="currentColor" stroke="none" />
                    <circle cx="20.8" cy="8.8" r="0.9" fill="currentColor" stroke="none" />
                </svg>
            ),
        },
    ];

    const handleOverallMetalColor = (value) => {
        setOverMetalColor(value);
        const suffix = colorSuffixMap[value] ?? '';
        setRingCategoryList(prev => prev.map(item => ({
            ...item,
            src: `https://hologram.shahluxe.com/images/Ring-Builder/${item.item_no}${suffix}.png`,
        })));
    };

    useEffect(() => {
        if (!accessToken) return;
    }, [accessToken]);

    useEffect(() => {
        if (clinetDetails?.is_rec_dia == "No") {
            setIsRecDiamond(false);
        } else {
            setIsRecDiamond(true);
        }
        console.log(clinetDetails);
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        setAccountNo(clinetDetails?.account_no);
        if (clinetDetails?.account_no == 'W284'){
            getRingCategory('Most-Popular');
        }
        return () => window.removeEventListener("resize", handleResize);
    }, [clinetDetails]);

    const toggleChangePage = (value) => {
        console.log(value);
        handlePagesChanges(value, value === 'Main' ? ringCategory : undefined, undefined, value === 'Main' ? overAllMetalColor : undefined);
    };

    const getRingCategory = async (value) => {
        if (!accessToken) {
            console.warn("Access token is not available. Skipping getRingCategory request.");
            return;
        }
        try {
            setCategoryLoading(true);
            setRingCategory(value);
            const postCategory = await axios.post(`${CONSTANT.BASE_URL}api/Builder/fetchRingCategory`, {
                apiParams: { ring_category: value }
            });
            setRingCategoryList(postCategory.data);
            if (overAllMetalColor !== "White Gold") {
                handleOverallMetalColor(overAllMetalColor);
            }
        } catch (error) {
            console.error('Error fetching ring category:', error);
        } finally {
            setCategoryLoading(false);
        }
    };

    const handleSelectRingFromCategory = (item_name, item_id) => {
        setRingCategoryItem(item_name);
        handlePagesChanges('Main', ringCategory, { name: item_name, id: item_id }, overAllMetalColor);
    };

        return (
            <section className="content ring-banner-page worthmore-ring-banner">
                <div className="wm-hero">
                    <h1 className="wm-hero-heading">
                        {/* <span className="wm-ink">BUILD</span> <span className="wm-terracotta">YOUR RING</span> */}
                        {windowWidth > 950 ? (
                            <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/build_your_ring_oneline.png`} style={{ width: '50%', height: 'auto' }} />
                        ):(
                            <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/build_your_ring_mobile.png`} style={{ width: '100%', height: 'auto' }} />
                        )}
                    </h1>
                    <br/>
                    <div className="wm-tagline-banner">
                        {/* <span className="wm-cream">YOUR LOVE. YOUR STORY. </span>
                        <span className="wm-bright">YOUR RING.</span> */}
                        {windowWidth > 950 ? (
                            <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/single_ring_quote.png`} style={{ width: '50%', height: 'auto' }} />
                        ):(
                            <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/single_ring_quote.png`} style={{ width: '100%', height: 'auto' }} />
                        )}
                    </div>
                    <p className="wm-intro">
                        {windowWidth > 950 && (
                            <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/single_rin_quote_second.png`} style={{ width: '70%', height: 'auto' }} />
                        )}
                    </p>
                </div>
                <div className="wm-grid">
                    <div>
                        {windowWidth > 950 ?(
                            <div className="wm-hero-image-wrap">
                                <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/SingleRingBuilder.png`} alt="Ring Menu" />
                            </div>
                        ):(
                            <div className="banner-wrap">
                                <div className="banner-bg">
                                    <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/single_rin_quote_second.png`} style={{ width: '70%', height: 'auto' }} />
                                </div>
                                <div className="wm-hero-image-wrap banner-overlay" >
                                    <img src={`${CONSTANT.BASE_URL}images/SingleRingBuilder/SingleRingBuilder.png`} alt="Ring Menu" />
                                </div>
                                <div className="banner-button">
                                    {isRecDiamond && (
                                        <>
                                            <button className="wm-btn wm-btn-filled btn-diamond" onClick={() => toggleChangePage('Diamond')}>
                                                Start with a Diamond
                                            </button>
                                        </>
                                    )}
                                    <button className="wm-btn wm-btn-outline btn-setting" onClick={() => toggleChangePage('Main')}>
                                        Start with a Setting
                                    </button>
                                </div>
                            </div>
                        )}
                        <div className="wm-badges">
                            {WM_BADGES.map(badge => (
                                <div className="wm-badge" key={badge.label}>
                                    {badge.icon}
                                    <span>{badge.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="wm-text-details">
                        <p className="wm-step-intro">Finalizing your perfect ring is really simple.</p>
                        <h4 className="wm-step-heading">Two quick &amp; easy ways</h4>
                        <div className="wm-how-it-works">
                            <div className="wm-step-card">
                                <div className="wm-step-num">1</div>
                                <div>
                                    <h4>Start with a Center Diamond</h4>
                                    <p>Choose the diamond that speaks to you, then select your Ring Head and Ring Shank to complete the setting.</p>
                                </div>
                            </div>
                            <div className="wm-step-card">
                                <div className="wm-step-num">2</div>
                                <div>
                                    <h4>Start with a Setting</h4>
                                    <p>Pick a Ring Head, select your preferred Shank, and finish by adding the perfect Center Diamond.</p>
                                </div>
                            </div>
                        </div>
                        {windowWidth > 950 && (
                            <div className="wm-cta-row">
                                {isRecDiamond && (
                                    <>
                                        <button className="wm-btn wm-btn-filled btn-diamond" onClick={() => toggleChangePage('Diamond')}>
                                            Start with a Diamond
                                        </button>
                                        <span className="wm-or">OR</span>
                                    </>
                                )}
                                <button className="wm-btn wm-btn-outline btn-setting" onClick={() => toggleChangePage('Main')}>
                                    Start with a Setting
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <hr className="wm-divider" />

                <div className="wm-suggestions-head">
                    <h3>Explore Infinite Designs with Effortless Imagination</h3>
                    <div className="wm-brush-label">suggestions to get you started</div>
                </div>

                <div className="wm-suggestions-grid">
                    <div className="wm-controls">
                        <div className="form-group">
                            <CommonFilter filterKey='ring_category' inputType='select' onChange={(value) => getRingCategory(value)} selectedValue={ringCategory} name="ring_category" labelName='Ring Category' />
                        </div>
                        <div className="form-group">
                            <label><span style={{ color: 'red' }}>*</span>Metal Color:</label>
                            {renderWorthmoreSwatches(overAllMetalColor, handleOverallMetalColor)}
                        </div>
                    </div>
                    <div className="wm-carousel-col">
                        {categoryLoading ? (
                            <SpinnerComponent />
                        ) : (
                            ringCategoryList.length > 0 && (
                                <SliderImages requestOption={ringCategoryList} labelName={'Shank'} selectedValue={ringCategoryItem} onChange={(e) => handleSelectRingFromCategory(e.target.value, e.target.dataset.id)} textName="ring_category" />
                            )
                        )}
                    </div>
                </div>
            </section>
        );
};

export default RingBanner;
